import { memo, useCallback, useMemo } from "react"
import { Typography, Stack, Switch } from "@mui/material"

function TripleEXFilter({ modifiers: { selections, setSelections }, align = "center" }) {
    const isTripleEX = useMemo(() => (
        selections.cut?.has('EX') && 
        selections.polish?.has('EX') && 
        selections.symm?.has('EX') &&
        selections.cut?.size === 1 &&
        selections.polish?.size === 1 &&
        selections.symm?.size === 1
    ), [selections])

    const handleTripleEXToggle = useCallback((event) => {
        const checked = event.target.checked
        setSelections(prev => ({
            ...prev,
            cut: checked ? new Set(['EX']) : new Set(),
            polish: checked ? new Set(['EX']) : new Set(),
            symm: checked ? new Set(['EX']) : new Set(),
        }))
    }, [setSelections])

    const isLeftAligned = align === 'left'

    return (
        <Stack
            direction="row"
            spacing={1.5}
            alignItems="center"
            sx={{
                width: '100%',
                justifyContent: isLeftAligned ? 'flex-start' : 'center',
                pl: isLeftAligned ? 1.25 : 0
            }}
        >
            <Typography variant="body2" color={!isTripleEX ? 'text.primary' : 'text.secondary'}>All</Typography>
            <Switch 
                checked={isTripleEX} 
                onChange={handleTripleEXToggle} 
                size="small" 
                color="primary"
            />
            <Typography variant="body2" color={isTripleEX ? 'text.primary' : 'text.secondary'} sx={{ fontWeight: isTripleEX ? 600 : 400 }}>
                Triple EX
            </Typography>
        </Stack>
    )
}

export default memo(TripleEXFilter)
